import { render, staticRenderFns } from "./FormFieldConstructorItem.vue?vue&type=template&id=5dc414d8"
import script from "./FormFieldConstructorItem.vue?vue&type=script&lang=js"
export * from "./FormFieldConstructorItem.vue?vue&type=script&lang=js"
import style0 from "./FormFieldConstructorItem.vue?vue&type=style&index=0&id=5dc414d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports